import type {
  DeletePreviewRow,
  DeletePreviewSplitRow,
} from '../../../../graphql/contentLabels/queryContentLabelDeletePreviews';
import type { BudgetConstraintImpact } from '../types';

export function toBudgetConstraintImpacts(
  rows: readonly DeletePreviewRow[],
  splits: readonly DeletePreviewSplitRow[] | null,
): BudgetConstraintImpact[] {
  const splitNamesByPortfolio = splits
    ? new Map(
        splits.map(({ portfolio }) => [
          portfolio.portfolioId,
          portfolio.budgetConstraints.contentLabelCategories.map(({ name }) => name),
        ]),
      )
    : null;

  return rows
    .map(({ budgetConstraintDeletionCount, portfolio }) => ({
      portfolioId: portfolio.portfolioId,
      title: portfolio.title,
      limitCount: budgetConstraintDeletionCount,
      splitNames: splitNamesByPortfolio?.get(portfolio.portfolioId) ?? null,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));
}
